<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <!-- <Sidebar></Sidebar> -->

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <div class="hidden-xs">    
                        <center>
                            <img src="static/config/logo.png" class="logo-inicio">
                        </center>
                    </div>      


                    <div class="hidden-xs row margin-bottom-30">
                        <div class="col-xl-12">
                            <button class="button small gray" type="button" v-on:click="$root.back()">
                                <i class="las la-arrow-left"></i> Voltar
                            </button>
                        </div>
                    </div>

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs margin-bottom-20">
                        <h3>
                            <img src="static/images/icones/wallet.png" style="height: 50px">
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>

                    <!-- Row -->
                    <div class="row">
                                       
                        <div class="col-xl-12">


                            <form v-show="mostrarFiltro" method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="get" novalidate>
                                <div class="row right-xs margin-bottom-20">

                                    <div class="hidden-xl hidden-lg hidden-md col-xs-12" style="text-align: right;">
                                        <button type="button" v-on:click="mostrarFiltro = false;" class="button small gray margin-bottom-20">
                                            <i class="las la-angle-up"></i>
                                            Esconder filtros
                                        </button>      
                                    </div>

                                    <div v-if="$root.user.tipo == 'admin'" class="col-lg-4 col-xs-12 col-xl-4 col-md-6">
                                        <div class="submit-field">
                                            <h5>Profissional:</h5>
                                            <autocomplete ref="ProfissionalNome" :search="searchAutocompleteProfissional" placeholder="Pesquise o profissional aqui.." aria-label="Pesquise o profissional aqui.." :get-result-value="getResultAutocompleteProfissional" @submit="submitAutocompleteProfissional"></autocomplete>

                                            <!-- <input type="text" class="with-border margin-bottom-0" placeholder="Escreva o nome.." name="pesquisa" v-model="form.solicitante"> -->
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-xs-6 col-xl-2 col-md-4" style="padding-right: 0px;">
                                        <div class="submit-field">
                                            <h5>Filtro por data:</h5>
                                            <select class="with-border" v-model="form.filtroData">
                                                <option default="" value="">Selecione..</option>
                                                <option value="DT_PAGAMENTO">Data de pagamento</option>
                                                <option value="DT_ENTRADA">Data de entrada</option>
                                                <option value="DT_ENVIO_CONVENIO">Data de envio convênio</option>                                
                                                <option value="DT_FATURAMENTO">Data de faturamento</option>                                
                                            </select>
                                        </div>
                                    </div>                                       
                                    <div class="col-lg-4 col-xs-6 col-xl-2 col-md-5">
                                        <div class="submit-field">
                                            <h5>De:</h5>
                                            <input type="date" data-placeholder="__ /__ /____" required="" class="with-border margin-bottom-0" v-model="form.dataInicio">
                                        </div>
                                    </div>        
                                    <div class="col-lg-4 col-xs-6 col-xl-2 col-md-5">
                                        <div class="submit-field">
                                            <h5>Até:</h5>
                                            <input type="date" data-placeholder="__ /__ /____" required="" class="with-border margin-bottom-0" v-model="form.dataFinal">
                                        </div>
                                    </div>                                          
                                    <div class="col-lg-3 col-xs-6 col-xl-2 col-md-4" style="padding-right: 0px;">
                                        <div class="submit-field">
                                            <h5>Status:</h5>
                                            <select class="with-border" v-model="form.status">
                                                <option default="" value="">Selecione..</option>
                                                <option value="">Todos</option>
                                                <option value="Faturado">Faturado</option>
                                                <option value="Previsto">Previsto</option>
                                                <option value="Glosa">Glosa</option>                                
                                                <option value="Pago">Pago</option>                                
                                            </select>
                                        </div>
                                    </div>     
<!--                                     <div class="col-lg-3 col-xs-6 col-xl-3 col-md-4" style="padding-right: 0px;">
                                        <div class="submit-field">
                                            <h5>Tipo:</h5>
                                            <select class="with-border" v-model="form.tipo">
                                                <option default="" value="">Selecione..</option>
                                            </select>
                                        </div>
                                    </div> -->                  
                                    <div class="col-lg-3 col-md-2 col-xs-4 hidden-xs hidden-md">
                                        <div class="submit-field">
                                            <div v-if="$root.user.tipo == 'profissional'" class="hidden-xs clearfix" style="margin-top: 21px;"></div>
                                            <button class="button small green" style="height: 40px;">
                                                <i class="las la-search"></i>
                                                Pesquisar
                                            </button>  
                                            <button type="button" v-on:click="mostrarFiltro = false;" class="button small gray" style="height: 40px;">
                                                <i class="las la-angle-up"></i>
                                                Esconder filtros
                                            </button>                                                                                      
                                        </div>
                                    </div>
                                    <div class="col-xs-7 margin-bottom-20 padding-top-12 col-md-7">
                                        <small style="display: block; line-height: 130%"><b>{{data.total}}</b> resultado(s) encontrado(s).</small>
                                    </div>

                                    <div class="col-lg-3 col-md-3 col-xs-5 hidden-xl hidden-lg" style="text-align: right;">
                                        <div class="submit-field">
                                            <div class="hidden-xl hidden-lg margin-top-10"></div>
                                            <div class="hidden-xs hidden-md clearfix" style="margin-top: 32px;"></div>
                                            <button class="button small green block-mobile">
                                                <i class="las la-search"></i>
                                                Pesquisar
                                            </button> 

                                        </div>
                                    </div>
                                </div>
                                <div class="hidden-sm hidden-xl hidden-lg margin-top-20"></div>
                            </form> 

                            <button v-if="!mostrarFiltro" type="button" v-on:click="mostrarFiltro = true;" class="hidden-lg hidden-md hidden-xl button small gray margin-bottom-20 float-right">
                                <i class="las la-angle-down"></i>
                                Mostrar filtros
                            </button>

                            <button v-if="!mostrarFiltro" type="button" v-on:click="mostrarFiltro = true;" class="hidden-xs button small gray margin-bottom-20">
                                <i class="las la-angle-down"></i>
                                Mostrar filtros
                            </button>                            
                        </div>
                        <div v-bind:class="{'disabled': !form.profissionalCodigo && $root.user.tipo == 'admin'}"  class="col-xl-12">
                            <div class="row">
                                <div class="col-xl-4 col-xs-12 margin-bottom-20">
                                    <div class="widget-card">
                                        <h2>
                                            <i class="las la-money"></i> {{data.metricas.ATENDIMENTOS || 0}}
                                        </h2>
                                        <p>
                                            Total de atendimentos
                                        </p>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-xs-12 margin-bottom-20">
                                    <div class="widget-card">
                                        <h2>
                                            <i class="las la-money"></i> {{data.metricas.PROCEDIMENTOS || 0}}
                                        </h2>
                                        <p>
                                            Total de procedimentos
                                        </p>
                                    </div>
                                </div>                                
                                <div class="col-xl-4 col-xs-12 margin-bottom-20">
                                    <div class="widget-card">
                                        <h2>
                                            <i class="las la-money"></i> R$ {{(data.metricas.FATURADO ? data.metricas.FATURADO : 0) | toMoney}}
                                        </h2>
                                        <p>
                                            Total faturado
                                        </p>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-xs-12 margin-bottom-20">
                                    <div class="widget-card">
                                        <h2>
                                            <i class="las la-money"></i> R$ {{(data.metricas.GLOSA ? data.metricas.GLOSA : 0) | toMoney}}
                                        </h2>
                                        <p>
                                            Total glosa
                                        </p>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-xs-12 margin-bottom-20">
                                    <div class="widget-card">
                                        <h2>
                                            <i class="las la-money"></i> R$ {{(data.metricas.PAGO ? data.metricas.PAGO : 0) | toMoney}}
                                        </h2>
                                        <p>
                                            Total pago
                                        </p>
                                    </div>
                                </div>      
                                <div class="col-xl-4 col-xs-12 margin-bottom-20">
                                    <div class="widget-card">
                                        <h2>
                                            <i class="las la-money"></i> R$ {{(data.metricas.PRODUCAO ? data.metricas.PRODUCAO : 0) | toMoney}}
                                        </h2>
                                        <p>
                                            Total da produção
                                        </p>
                                    </div>
                                </div>                                                                                                
                            </div>
                            <div class="clearfix"></div>
                        </div>

                        <div v-bind:class="{'disabled': !form.profissionalCodigo && $root.user.tipo == 'admin'}" class="col-xl-12 margin-top-20">
                            <h4 style="display: block; line-height: 130%;">
                                <i class="las la-clock"></i> 
                                Histórico de recebíveis

                                <button v-on:click="exportar" type="button" class="button hidden-xs small color-primary float-right" style="margin-top: -20px;">
                                    <i class="las la-download" style="color: #fff !important; top: 0px;"></i> 
                                    Salvar em PDF
                                </button>

                            </h4>
                            <button v-on:click="exportar" type="button" class="button hidden-xl hidden-md hidden-lg hidden-sm small color-primary block-mobile margin-bottom-20 margin-top-10" >
                                <i class="las la-download" style="color: #fff !important; top: 0px;"></i> 
                                Salvar em PDF
                            </button>
                            <div class="hidden-xs margin-top-10"></div>
                        </div>

                        <div v-bind:class="{'disabled': !form.profissionalCodigo && $root.user.tipo == 'admin'}" class="col-xl-12">


                            <h5 v-show="data.itens.length == 0 && data.loaded" class="empty">
                                <i class="las la-times"></i>
                                Nenhum resultado encontrado.
                            </h5>

                            <div class="table-scroll parent" style="overflow-x: scroll; border: 1px solid #ddd" v-show="data.itens.length > 0">

                                <table class="table child table-bordered table-bordered-default table-responsive" style="margin-bottom: 0px !important">
                                    <thead>
                                        <th style="min-width: 70px; width: 70px;">
                                            Atendimento
                                        </th>                                                              
                                        <th style="min-width: 90px; width: 90px;">
                                            Conta guia
                                        </th>   
                                        <th style="min-width: 270px; width: 270px">
                                            Paciente
                                        </th>
                                        <th style="min-width: 200px; width: 200px;" >
                                            Procedimento
                                        </th>      
                                        <th style="min-width: 200px; width: 200px;" >
                                            Setor atendimento
                                        </th>                                       
                                        <th style="min-width: 170px; width: 170px;" >
                                            Tipo receita
                                        </th>                              
                                        <th style="min-width: 170px; width: 170px;" >
                                            Convênio
                                        </th>                                                        
                                        <th style="min-width: 115px; width: 115px; text-align: center;">
                                            Previsto (R$)
                                        </th>                                        
                                        <th style="min-width: 115px; width: 115px; text-align: center;">
                                            Faturado (R$)
                                        </th>
                                        <th style="min-width: 115px; width: 115px; text-align: center;">
                                            Pago (R$)
                                        </th>
                                        <th style="min-width: 115px; width: 115px; text-align: center;">
                                            Glosado (R$)
                                        </th>                                        
                                        <th style="min-width: 140px; width: 140px;" >
                                            Data de entrada
                                        </th>              
                                        <th style="min-width: 140px; width: 140px;" >
                                            Data de faturamento
                                        </th>                                                                                              
                                        <th style="min-width: 140px; width: 140px;" >
                                            Data de envio convênio
                                        </th>
                                        <th style="min-width: 140px; width: 140px;" >
                                            Data de pagamento
                                        </th>                
<!--                                         <th style="min-width: 100px; width: 100px;">
                                            Status
                                        </th>    -->                                     
                                    </thead>
                                    <tbody>   

                                        <tr v-for="item in data.itens">
                                            <td data-label="">
                                                <span class="hidden-xl hidden-lg" style="font-size: 16px; font-weight: 500">Número: #{{item.NR_ATENDIMENTO}}</span><span style="font-size: 16px; font-weight: 500;" class="hidden-xs">#{{item.NR_ATENDIMENTO}}</span>
                                            </td>                                         
                                            <td data-label="Conta guia">
                                                {{item.GUIA}}
                                            </td>
                                            <td data-label="Paciente">
                                                {{item.NM_PACIENTE}}
                                            </td>
                                            <td data-label="Procedimento">
                                                {{item.DS_PROCEDIMENTO}}
                                            </td>                                            
                                            <td data-label="Setor atendimento">
                                                {{item.DS_SETOR_ATENDIMENTO}}
                                            </td>
                                            <td data-label="Tipo receita">
                                                {{item.DS_TIPO_RECEITA}}
                                            </td>
                                            <td data-label="Convênio">
                                                {{item.DS_CONVENIO}}
                                            </td>
                                            <td data-label="Previsto (R$)" style="text-align: center; color: #000; font-weight: 500 !important">
                                               R$ {{item.IE_PREVISTO | toMoney}}
                                            </td>
                                            <td data-label="Faturado (R$)" style="text-align: center; color: #000; font-weight: 500 !important">
                                               R$ {{item.IE_FATURADO | toMoney}}
                                            </td>
                                            <td data-label="Pago (R$)" style="text-align: center; color: #000; font-weight: 500 !important">
                                               R$ {{item.IE_PAGO | toMoney}}
                                            </td>
                                            <td data-label="Glosado (R$)" style="text-align: center; color: #000; font-weight: 500 !important">
                                               R$ {{item.IE_GLOSA | toMoney}}
                                            </td>                                            
                                            <td data-label="Data de entrada">
                                                {{item.DT_ENTRADA | formatDate}}
                                            </td>
                                            <td data-label="Data de faturamento">
                                                {{item.DT_FATURAMENTO | formatDate}}
                                            </td>                                            
                                            <td data-label="Data de envio convênio">
                                                {{item.DT_ENVIO_CONVENIO | formatDate}}
                                            </td>
                                            <td data-label="Data de pagamento">
                                                {{item.DT_PAGAMENTO | formatDate}}
                                            </td>
                                            <!-- <td data-label="Status"> -->
                                               <!-- <span class="dashboard-status-button color-orange">Pendente</span> -->
<!--                                                <span v-if="item.IE_APROV_REPROV == 'P'" class="dashboard-status-button color-orange">Pendente</span>
                                               <span v-if="item.IE_APROV_REPROV == 'B'" class="dashboard-status-button color-blue">Baixado</span>
                                               <span v-if="item.IE_APROV_REPROV == 'A'" class="dashboard-status-button color-green">Aprovado</span>
                                               <span v-if="item.IE_APROV_REPROV == 'R'" class="dashboard-status-button color-red">Reprovado</span>
 -->
                                            <!-- </td>     -->
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                            <div class="pagination-container margin-top-60 margin-bottom-60">
                                <nav class="pagination">
                                    <ul>
                                        <li class="pagination-arrow" v-show="data.page > 1" v-on:click="form.page = (data.page - 1); get();">
                                            <a>
                                                <i class="las la-arrow-left"></i>
                                                Anterior
                                            </a>
                                        </li>
                                        <li class="pagination-arrow" v-show="data.page >= 1 && data.page < (data.pages.length)" v-on:click="form.page = (data.page + 1); get();">
                                            <a>
                                                Próxima
                                                <i class="las la-arrow-right"></i>
                                            </a>
                                        </li>    
                                        <br class="hidden-lg hidden-xl hidden-md">                                        
                                        <li v-for="(item, index) in data.pages" v-show="item.show">
                                            <a class="" v-bind:class="{'current-page': item.index == data.page}" v-on:click="form.page = item.index; get();">
                                                {{item.index}}
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>                                
                        </div>                    
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'HonorariosMedicos',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2});
            } else {
                return "0,00";
            }
        },          
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            return date + (time ? (" " + time) : "");
        } ,
        formatDate2: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            return date;
        }          
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "mostrarFiltro":        true,
            "data":                 {
                "itens":            [],
                "metricas":         {},
                "total":            0
            },                 
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "status":           "",
                "filtroData":       "",
                "profissionalCodigo":  null,
                "dataInicio":       "",
                "dataFinal":        "",
                "tipo":             "",
                "page":             1,
                "pesquisa":         ""
            }              
        }
    },
    methods: {    
        exportar: function() {
            var self = this;
            console.log("exportarExame()");
            loading.show();

            return new Promise(function(resolve, reject) {

                var form    = JSON.parse(JSON.stringify(self.form));
                delete      form.profissional;
                form.acao   = "exportar";
                    
                axios.put("api/honorarios-medicos.php", form)
                .then(response => {

                    console.log("exportar()", "success", response.data.link)
                    loading.hide();
                    window.open(response.data.link, "_system");
                    // alert(response.data.message);

                })
                .catch(error => {

                    console.log("exportar()", "error", error.data)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

                });
            });   
        },
        getResultAutocompleteProfissional: function(result) {
          return (result.NM_PESSOA_FISICA);
        },   
        submitAutocompleteProfissional: function(obj) {
            console.log("Profissional:", obj)
            var self = this;
            self.form.profissional          = obj;
            self.form.profissionalCodigo    = obj.CD_PESSOA_FISICA;
            self.$forceUpdate();

            self.form.page = 1;
            self.get();
        },
        searchAutocompleteProfissional: function(val) {
            var self = this;
            return new Promise(function(resolve, reject) {

                if (self.requestAutocomplete) {
                    self.requestAutocomplete.cancel(); 
                }

                self.requestAutocomplete = axios.CancelToken.source();  
                
                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "page":         1,
                        "campo":        "NM_PESSOA_PESQUISA",
                        "autocomplete": true,
                        "pesquisa":     val
                    },
                    "cancelToken":      self.requestAutocomplete.token  
                };

                axios.get("api/profissionais.php", form)
                .then(response => {
                    
                    resolve(response.data.result.itens);
  
                })
                .catch(error => {
                    loading.hide();
                    reject(error);
                }); 

            });
        },          
        get: function(noScroll) {
            var self        = this;
            console.log("get()", self.form);
            loading.show();

            return new Promise(function(resolve, reject) {

                if (!self.form.profissionalCodigo && self.$root.user.tipo == "admin") {
                    self.data.loaded = true;
                    self.$forceUpdate();
                    loading.hide();
                    resolve(null);
                    return false;
                }

                var form = JSON.parse(JSON.stringify(self.form));
                delete form.profissional;

                axios.get("api/honorarios-medicos.php", {params: form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    self.loaded = true;
                    loading.hide();
                    if (!noScroll) {
                        self.$root.scrollTop();
                    }

                    self.$root.tmp.honorariosMedicos           = JSON.parse(JSON.stringify(response.data.result));
                    self.$root.tmp.honorariosMedicosForm       = JSON.parse(JSON.stringify(self.form));

                    self.$forceUpdate();
                    self.$root.$forceUpdate();

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }   
    },
    created: function() {
        var self = this;
        // self.get();
        console.log("Aprovação Orçamentária -> created")
        loading.hide();
    },
    mounted: function() {
        var self = this;
        console.log("Aprovação Orçamentária -> mounted")

        if (self.$root.mobile.isMobile) {
            self.mostrarFiltro = false;
        }

        var noScroll    = false;

        if (self.$root.tmp.honorariosMedicos) {

            self.form   = JSON.parse(JSON.stringify(self.$root.tmp.honorariosMedicosForm));
            self.data   = JSON.parse(JSON.stringify(self.$root.tmp.honorariosMedicos));
            self.$root.$forceUpdate();
            self.$forceUpdate();
            noScroll    = true;
        }

        Promise.all([
            self.get(noScroll),
        ]).then(function() {
            self.initLoaded = true;
            
            if (self.$root.loaded) {
                if (window.__app.$route.name == "Dashboard") {
                    loading.hide();
                }
            }
        }).catch(function(error) {
            // loading.hide();
            self.initLoaded = true;
            self.$forceUpdate();  
            if (self.$root.loaded) {

                loading.hide();
            }              
        });          
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    @media only screen and (max-width: 500px) { 

        td {
            text-align: left !important;
        }
    }


    .submit-field {
        margin-bottom: 15px;
    }

    .dashboard-status-button i {
        color: #fff !important;
    }

    .dashboard-status-button.block-mobile {
        text-align: center !important;
        font-weight: 400;
/*        font-size: 13px;*/
        width: 100%;
    }

    .widget-card {
        width: 100%;
        background: #efefef;
        padding: 10px;
        text-align: center;
        border-radius: 20px;
    }
    .widget-card h2 {
        font-size: 30px; 
        font-weight: bold; 
        margin-top: 15px;
        margin-bottom: 10px;
    }
    .widget-card p {
        margin-bottom: 10px;
        line-height: 130%;
    }

    th {
/*        padding-top: 10px;*/
    }

</style>



// WEBPACK FOOTER //
// src/components/HonorariosMedicos.vue